import { render, staticRenderFns } from "./renewTable.vue?vue&type=template&id=528d8dda&scoped=true&"
import script from "./renewTable.vue?vue&type=script&lang=js&"
export * from "./renewTable.vue?vue&type=script&lang=js&"
import style0 from "./renewTable.vue?vue&type=style&index=0&id=528d8dda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528d8dda",
  null
  
)

export default component.exports